import GetAnalyticsForCompanyRequestModelBase from '../_generated/modelBases/get-analytics-for-company-request-model-base';

export default class GetAnalyticsForCompanyRequestModel extends GetAnalyticsForCompanyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
